<section class="container" *ngIf="!isP10MCustomer; else elseBlock">
  <div role="tablist">
    <p-accordion [multiple]="isNewDesignEnabled ? false : true" id="account-lines">
      <ng-container
        (onOpen)="updateActiveBladeIndex(idx, true)"
        (onClose)="updateActiveBladeIndex(idx, false)"
        *ngFor="
          let line of accountLineDetailsModel?.customerAccountLineDetails;
          let idx = index;
          let first = first
        "
      >
        <ng-container *ngIf="isNewDesignEnabled; else oldLineDesign">
          <div class="account-lines-container">
            <ng-container *ngIf="line?.devicedetails?.lines[0]?.imageURL; else noImageAvailable">
              <img
                id="device-image"
                class="img-fluid account-line-image"
                [src]="extTmoImagesUrl + line?.devicedetails?.lines[0]?.imageURL"
                alt="FPO Image"
              />
            </ng-container>
            <ng-template #noImageAvailable>
              <img
                id="no-image"
                class="img-fluid account-line-image"
                [src]="imageUrl"
                alt="FPO Image"
              />
            </ng-template>
            <p-accordionTab
              class="account-line-details-tab"
              id="line-{{ idx }}"
              [selected]="first"
              (click)="onLineBladeClick(line?.msisdn, idx)"
            >
              <p-header>
                <div class="row n-p" class="account-line-header-section">
                  <div class="account-line-header-msisdn">
                    <div class="title account-msisdn-style" id="msisdn-line-{{ idx }}">
                      {{ line?.msisdn | phone }}
                    </div>
                    <div
                      class="title"
                      *ngIf="line?.primaryLineIndicator.toLowerCase() === primaryConstant"
                    >
                      ,{{ ' ' + line?.primaryLineIndicator }}
                    </div>
                    <div
                      class="title"
                      *ngIf="line?.lineStatus !== ACC_LANDING_CONSTANTS_OBJECT.SUSPENDED"
                    >
                      {{ ', ' + line?.lineStatus }}
                    </div>
                    <div
                      class="title"
                      *ngIf="line?.lineStatus === ACC_LANDING_CONSTANTS_OBJECT.SUSPENDED"
                    >
                      {{ ', ' + line?.lineStatus }} - {{ getSubStatus(line) }}
                    </div>
                  </div>
                  <div class="account-line-header-links">
                    <p>
                      <a
                        [routerLink]="[]"
                        id="line-details"
                        [attr.aria-label]="contentData?.lineDetails"
                        (click)="onLineDetailsClick(line)"
                        >{{ contentData?.lineDetails }}</a
                      >
                    </p>
                    <p>
                      <a
                        [routerLink]="[]"
                        id="browse-phones"
                        *ngIf="line?.lineStatus !== ACC_LANDING_CONSTANTS_OBJECT.CANCELLED"
                        [class.disabled]="!isPermissionAvailable || !isUpgradePermissionAvailable"
                        [attr.aria-label]="contentData?.upgradeDevice"
                        tmoUIPermission
                        [targetName]="permissionConstants.CREATE_SCORE_UPGRADE"
                        (click)="navigateToLineUpgrade(line?.lineOfServiceId)"
                        >{{ contentData?.upgradeDevice }}</a
                      >
                    </p>
                  </div>
                </div>
              </p-header>
              <div class="p-content">
                <div class="accordian-plan-section">
                  <div class="line-plan-section">
                    <div class="m-t-xs line-plan-name" id="plan-line-{{ idx }}">
                      {{ line?.planName }}
                    </div>
                    <div>
                      <a
                        class="m-t-xs"
                        id="edit-plan"
                        href="javascript:void(0)"
                        id="editPlan"
                        (click)="
                          isTouristPlan ||
                          line?.lineStatus === ACC_LANDING_CONSTANTS_OBJECT.CANCELLED ||
                          !permissionEnabled
                            ? null
                            : navigateToCPS(line)
                        "
                        [attr.aria-label]="contentData?.editPlan"
                        [class.disabled]="
                          isTouristPlan ||
                          line?.lineStatus === ACC_LANDING_CONSTANTS_OBJECT.CANCELLED ||
                          !permissionEnabled
                        "
                        >{{ contentData?.editPlan }}</a
                      >
                    </div>
                  </div>
                  <div
                    *ngIf="pendingOrdersCount > 0"
                    class="small pending-orders-text"
                    id="order-line-{{ idx }}"
                  >
                    {{ line?.pendingOrders }}
                  </div>
                </div>
              </div>
            </p-accordionTab>
          </div>
        </ng-container>
        <ng-template #oldLineDesign>
          <p-accordionTab
            id="line-{{ idx }}"
            [selected]="first"
            (click)="onLineBladeClick(line?.msisdn, idx)"
          >
            <p-header>
              <div class="row n-p">
                <div class="col-12">
                  <h6 class="title" id="msisdn-line-{{ idx }}">{{ line?.msisdn | phone }}</h6>
                  <p
                    class="blade-desc"
                    *ngIf="
                      !line?.isActive && line?.lineStatus !== ACC_LANDING_CONSTANTS_OBJECT.SUSPENDED
                    "
                  >
                    {{ line?.lineStatus }}, {{ line?.pendingOrders }}
                  </p>
                  <p
                    class="blade-desc"
                    *ngIf="
                      !line?.isActive && line?.lineStatus === ACC_LANDING_CONSTANTS_OBJECT.SUSPENDED
                    "
                  >
                    {{ line?.lineStatus }} - {{ getSubStatus(line) }}, {{ line?.pendingOrders }}
                  </p>
                </div>
              </div>
            </p-header>
            <div class="p-content">
              <div class="row">
                <div class="col-2 col-md-1 text-center n-padding">
                  <ng-container
                    *ngIf="line?.devicedetails?.lines[0]?.imageURL; else noImageAvailable"
                  >
                    <img
                      id="device-image"
                      class="img-fluid"
                      [src]="extTmoImagesUrl + line?.devicedetails?.lines[0]?.imageURL"
                      alt="FPO Image"
                    />
                  </ng-container>
                  <ng-template #noImageAvailable>
                    <img id="no-image" class="img-fluid" [src]="imageUrl" alt="FPO Image" />
                  </ng-template>
                </div>
                <div class="col-10 col-md-11">
                  <ng-container *ngFor="let device of line?.devicedetails?.lines">
                    <p class="lead">{{ device?.devicename }}</p>
                  </ng-container>
                  <p
                    class="small m-t-xs"
                    *ngIf="line?.primaryLineIndicator?.toLowerCase() === primaryConstant"
                  >
                    {{ line?.primaryLineIndicator }}
                  </p>
                  <p
                    class="small m-t-xs"
                    *ngIf="line?.lineStatus !== ACC_LANDING_CONSTANTS_OBJECT.SUSPENDED"
                  >
                    {{ contentData?.lineStatus }}: {{ line?.lineStatus }}
                  </p>
                  <p
                    class="small m-t-xs"
                    *ngIf="line?.lineStatus === ACC_LANDING_CONSTANTS_OBJECT.SUSPENDED"
                  >
                    {{ contentData?.lineStatus }}: {{ line?.lineStatus }} - {{ getSubStatus(line) }}
                  </p>
                  <div class="row m-t-md">
                    <div class="col-8">
                      <p class="bold">{{ contentData?.plan }}</p>
                      <p class="m-t-xs" id="plan-line-{{ idx }}">{{ line?.planName }}</p>
                      <ng-container *ngIf="line?.services?.length">
                        <p class="m-t-sm">{{ contentData?.addService }}</p>
                        <ng-container *ngFor="let service of line?.services">
                          <p *ngIf="service?.display" class="small m-t-xs">
                            {{ service?.displayName }}
                          </p>
                        </ng-container>
                      </ng-container>
                      <p class="small m-t-md" id="order-line-{{ idx }}">
                        {{ line?.pendingOrders }}
                      </p>
                    </div>
                    <div class="col-4 text-end">
                      <p>
                        <a
                          id="edit-plan"
                          href="javascript:void(0)"
                          id="editPlan"
                          (click)="
                            isTouristPlan ||
                            line?.lineStatus === ACC_LANDING_CONSTANTS_OBJECT.CANCELLED ||
                            !permissionEnabled
                              ? null
                              : navigateToCPS(line)
                          "
                          [attr.aria-label]="contentData?.editPlan"
                          [class.disabled]="
                            isTouristPlan ||
                            line?.lineStatus === ACC_LANDING_CONSTANTS_OBJECT.CANCELLED ||
                            !permissionEnabled
                          "
                          >{{ contentData?.editPlan }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 buttons-container button-spacing-legal">
                  <div class="button-box">
                    <button
                      id="browse-phones"
                      *ngIf="line?.lineStatus !== ACC_LANDING_CONSTANTS_OBJECT.CANCELLED"
                      [disabled]="!isPermissionAvailable || !isUpgradePermissionAvailable"
                      class="btn btn-secondary"
                      [attr.aria-label]="contentData?.upgradeDevice"
                      tmoUIPermission
                      [targetName]="permissionConstants.CREATE_SCORE_UPGRADE"
                      (click)="navigateToLineUpgrade(line?.lineOfServiceId)"
                    >
                      {{ contentData?.upgradeDevice }}
                    </button>
                  </div>
                  <div class="button-box">
                    <button
                      id="line-details"
                      class="btn btn-secondary"
                      [attr.aria-label]="contentData?.lineDetails"
                      (click)="onLineDetailsClick(line)"
                    >
                      {{ contentData?.lineDetails }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </p-accordionTab>
        </ng-template>
      </ng-container>
    </p-accordion>
  </div>
  <div class="row m-t-xl m-b-xxl"></div>
</section>
<ng-template #elseBlock>
  <tmo-p10m-line-details
    id="line-details"
    [primaryMsisdn]="primaryMsisdn"
    [accountLineDetailsModel]="accountLineDetailsModel"
    [contentData]="contentData"
  ></tmo-p10m-line-details>
</ng-template>
